import 'css-chunksrc/client/scenes/wbsConfiguration/form/styles.scss';export default {
  "form": "_form_yr4vq_1",
  "group": "_group_yr4vq_5",
  "row": "_row_yr4vq_9",
  "label": "_label_yr4vq_19",
  "description": "_description_yr4vq_24",
  "roleSelection": "_roleSelection_yr4vq_28"
};